import { useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import axios from '../../api/axios'
import useTranslation from '../../hooks/useTranslation'
import { Input, Label, ErrorMsg } from './styles'

const Background = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
`

const Card = styled.section`
    background: ${({ theme }) => theme.area?.background || '#fff'};
    border: 1px solid ${({ theme }) => theme.border?.color || '#e5e7eb'};
    border-radius: 0.75rem;
    padding: 2rem;
    width: 100%;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
`

const Title = styled.h2`
    margin: 0;
    font-size: 1.2rem;
`

const Button = styled.button`
    padding: 0.65rem 1rem;
    background: ${({ theme }) => theme.button?.primary?.background || '#2563eb'};
    color: ${({ theme }) => theme.button?.primary?.color || '#fff'};
    border: none;
    border-radius: 0.5rem;
    font-size: 1rem;
    cursor: pointer;

    &:disabled { opacity: 0.6; cursor: not-allowed; }
`

const ResetPassword = () => {
    const { token } = useParams()
    const navigate = useNavigate()
    const { t } = useTranslation()
    const [password, setPassword] = useState('')
    const [confirm, setConfirm] = useState('')
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)

    const mismatch = confirm && password !== confirm

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!password || mismatch) return
        setLoading(true)
        setError(null)
        try {
            await axios.post('/portal/resetPassword', { token, password })
            navigate('/loggedout', { state: { message: 'portal.reset.password.success' } })
        } catch (err) {
            setError(err.response?.data?.error?.name || 'error.unknown')
            setLoading(false)
        }
    }

    return (
        <Background>
            <Card>
                <Title>{t('portal.reset.password.title')}</Title>
                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <Label>
                        {t('portal.reset.password.new.label')}
                        <Input
                            type="password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            autoFocus
                            placeholder={t('portal.reset.password.new.placeholder')}
                        />
                    </Label>
                    <Label>
                        {t('portal.reset.password.confirm.label')}
                        <Input
                            type="password"
                            value={confirm}
                            onChange={e => setConfirm(e.target.value)}
                            placeholder={t('portal.reset.password.confirm.placeholder')}
                        />
                    </Label>
                    {mismatch && <ErrorMsg>{t('portal.reset.password.mismatch')}</ErrorMsg>}
                    {error && <ErrorMsg>{t(error)}</ErrorMsg>}
                    <Button type="submit" disabled={loading || !password || mismatch}>
                        {loading ? t('portal.reset.password.saving') : t('portal.reset.password.submit')}
                    </Button>
                </form>
            </Card>
        </Background>
    )
}

export default ResetPassword
